import { useEffect, useState } from 'react'
import { useIdle } from '../../hooks';
import { millisToHoursAndMinutesAndSeconds } from '../../utilities/time';
import { IUseIdleParams, IUseIdleReturn } from '../../hooks/useIdle.hook';

interface RemainingTimerProps extends Pick<IUseIdleParams, 'throttle' | 'onAction'> {
    expiryInSecond: number;
    promptExpiryInSecond: number;
    hidden?: boolean;

    onIdle: () => void;
    onPrompt: (onReset: () => void) => void;
    onInterval?: (isPrompted: IUseIdleReturn['isPrompted'], remainingTime: ReturnType<IUseIdleReturn['getRemainingTime']>) => void;
}

const RemainingTimer = (props: RemainingTimerProps) => {
    const { expiryInSecond, promptExpiryInSecond, hidden, onIdle, onPrompt, onInterval, ...useIdleProps } = props;
    const [remainingTime, setRemainingTime] = useState<number>(0);

    const handlePrompt = () => {
        onPrompt(reset);
    }

    const { isIdle, getRemainingTime, reset, isPrompted } = useIdle({
        onIdle: onIdle,
        idleTime: expiryInSecond,
        onPrompt: handlePrompt,
        promptTime: promptExpiryInSecond,
        ...useIdleProps
    });

    useEffect(() => {
        let interval: NodeJS.Timeout;

        if (!isIdle) {
            interval = setInterval(() => {
                let remaingTime = getRemainingTime()
                setRemainingTime(remaingTime);
                onInterval?.(isPrompted, remaingTime);
            }, 1000);
        }

        return () => {
            clearInterval(interval);
        };
    }, [isIdle])

    if (hidden) return <></>;
    return <>{millisToHoursAndMinutesAndSeconds(remainingTime)}</>;
}

export default RemainingTimer